function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, Object, String) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['chartTooltipItem'] = function(item) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((item.type === $helpers.TooltipItemType.Data) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
            "attrs": {
              theme: item.theme ? item.theme : 'neutral',
              text: item.text,
            },
            "class": {
              'chart-tooltip-item': true
            },
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("span", {
            "class": Object.assign({}, {
              'chart-tooltip-section-strong': item.type === $helpers.TooltipItemType.Strong,
            }, {
              'chart-tooltip-item': true
            }),
          }, [__vjadeSafeCode(item.text)]));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'chart-tooltip': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'chart-tooltip-body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`title-color`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": {
                'background-color': $attr(`title-color`)
              },
              "class": {
                'chart-tooltip-color-indicator': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'chart-tooltip-sections': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($attr(`sections`));
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, section, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'chart-tooltip-section-container': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var $$obj = (section);
                        var $$eachNodes;
                        var $$iterated = false;
                        if (Array.isArray($$obj)) {
                          $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                            $$iterated = true;
                            return $$eachNodes.concat((function() {
                              var __jade_nodes = []; /*  there are subsections to be rendered */
                              __jade_nodes = __jade_nodes.concat((item.subsections) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'chart-tooltip-subsection-container': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "style": {
                                      'background': $helpers.getItemBackground(item)
                                    },
                                    "class": {
                                      'chart-tooltip-section-color-indicator': true
                                    },
                                  }));
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'chart-tooltip-subsection-item-container': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = []; /*  title of the subsection */
                                    __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, item));
                                    __jade_nodes = __jade_nodes.concat((function() {
                                      var $$obj = (item.subsections);
                                      var $$eachNodes;
                                      var $$iterated = false;
                                      if (Array.isArray($$obj)) {
                                        $$eachNodes = $$obj.reduce(function($$eachNodes, subsection, $index) {
                                          $$iterated = true;
                                          return $$eachNodes.concat((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": {
                                                'chart-tooltip-subsection-items': true
                                              },
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat((function() {
                                                var $$obj = (subsection);
                                                var $$eachNodes;
                                                var $$iterated = false;
                                                if (Array.isArray($$obj)) {
                                                  $$eachNodes = $$obj.reduce(function($$eachNodes, subSectionItem, $index) {
                                                    $$iterated = true;
                                                    return $$eachNodes.concat((function() {
                                                      var __jade_nodes = [];
                                                      __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                      return __jade_nodes
                                                    }).call(this));
                                                  }, []);
                                                } else {
                                                  $$eachNodes = [];
                                                  for (var $$objKey in $$obj) {
                                                    (function() {
                                                      var $index = $$objKey;
                                                      if ($$obj.hasOwnProperty($index)) {
                                                        $$iterated = true;
                                                        var subSectionItem = $$obj[$index];
                                                        $$eachNodes = $$eachNodes.concat((function() {
                                                          var __jade_nodes = [];
                                                          __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                          return __jade_nodes
                                                        }).call(this));
                                                      }
                                                    })();
                                                  }
                                                }

                                                return $$eachNodes;
                                              })());;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this));
                                        }, []);
                                      } else {
                                        $$eachNodes = [];
                                        for (var $$objKey in $$obj) {
                                          (function() {
                                            var $index = $$objKey;
                                            if ($$obj.hasOwnProperty($index)) {
                                              $$iterated = true;
                                              var subsection = $$obj[$index];
                                              $$eachNodes = $$eachNodes.concat((function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "class": {
                                                    'chart-tooltip-subsection-items': true
                                                  },
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat((function() {
                                                    var $$obj = (subsection);
                                                    var $$eachNodes;
                                                    var $$iterated = false;
                                                    if (Array.isArray($$obj)) {
                                                      $$eachNodes = $$obj.reduce(function($$eachNodes, subSectionItem, $index) {
                                                        $$iterated = true;
                                                        return $$eachNodes.concat((function() {
                                                          var __jade_nodes = [];
                                                          __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                          return __jade_nodes
                                                        }).call(this));
                                                      }, []);
                                                    } else {
                                                      $$eachNodes = [];
                                                      for (var $$objKey in $$obj) {
                                                        (function() {
                                                          var $index = $$objKey;
                                                          if ($$obj.hasOwnProperty($index)) {
                                                            $$iterated = true;
                                                            var subSectionItem = $$obj[$index];
                                                            $$eachNodes = $$eachNodes.concat((function() {
                                                              var __jade_nodes = [];
                                                              __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                              return __jade_nodes
                                                            }).call(this));
                                                          }
                                                        })();
                                                      }
                                                    }

                                                    return $$eachNodes;
                                                  })());;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));;
                                                return __jade_nodes
                                              }).call(this));
                                            }
                                          })();
                                        }
                                      }

                                      return $$eachNodes;
                                    })());;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, item));;
                                return __jade_nodes
                              }).call(this)));;
                              return __jade_nodes
                            }).call(this));
                          }, []);
                        } else {
                          $$eachNodes = [];
                          for (var $$objKey in $$obj) {
                            (function() {
                              var $index = $$objKey;
                              if ($$obj.hasOwnProperty($index)) {
                                $$iterated = true;
                                var item = $$obj[$index];
                                $$eachNodes = $$eachNodes.concat((function() {
                                  var __jade_nodes = []; /*  there are subsections to be rendered */
                                  __jade_nodes = __jade_nodes.concat((item.subsections) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'chart-tooltip-subsection-container': true
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "style": {
                                          'background': $helpers.getItemBackground(item)
                                        },
                                        "class": {
                                          'chart-tooltip-section-color-indicator': true
                                        },
                                      }));
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'chart-tooltip-subsection-item-container': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = []; /*  title of the subsection */
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, item));
                                        __jade_nodes = __jade_nodes.concat((function() {
                                          var $$obj = (item.subsections);
                                          var $$eachNodes;
                                          var $$iterated = false;
                                          if (Array.isArray($$obj)) {
                                            $$eachNodes = $$obj.reduce(function($$eachNodes, subsection, $index) {
                                              $$iterated = true;
                                              return $$eachNodes.concat((function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "class": {
                                                    'chart-tooltip-subsection-items': true
                                                  },
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat((function() {
                                                    var $$obj = (subsection);
                                                    var $$eachNodes;
                                                    var $$iterated = false;
                                                    if (Array.isArray($$obj)) {
                                                      $$eachNodes = $$obj.reduce(function($$eachNodes, subSectionItem, $index) {
                                                        $$iterated = true;
                                                        return $$eachNodes.concat((function() {
                                                          var __jade_nodes = [];
                                                          __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                          return __jade_nodes
                                                        }).call(this));
                                                      }, []);
                                                    } else {
                                                      $$eachNodes = [];
                                                      for (var $$objKey in $$obj) {
                                                        (function() {
                                                          var $index = $$objKey;
                                                          if ($$obj.hasOwnProperty($index)) {
                                                            $$iterated = true;
                                                            var subSectionItem = $$obj[$index];
                                                            $$eachNodes = $$eachNodes.concat((function() {
                                                              var __jade_nodes = [];
                                                              __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                              return __jade_nodes
                                                            }).call(this));
                                                          }
                                                        })();
                                                      }
                                                    }

                                                    return $$eachNodes;
                                                  })());;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));;
                                                return __jade_nodes
                                              }).call(this));
                                            }, []);
                                          } else {
                                            $$eachNodes = [];
                                            for (var $$objKey in $$obj) {
                                              (function() {
                                                var $index = $$objKey;
                                                if ($$obj.hasOwnProperty($index)) {
                                                  $$iterated = true;
                                                  var subsection = $$obj[$index];
                                                  $$eachNodes = $$eachNodes.concat((function() {
                                                    var __jade_nodes = [];
                                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                                      "class": {
                                                        'chart-tooltip-subsection-items': true
                                                      },
                                                    }, (function() {
                                                      var __jade_nodes = [];
                                                      __jade_nodes = __jade_nodes.concat((function() {
                                                        var $$obj = (subsection);
                                                        var $$eachNodes;
                                                        var $$iterated = false;
                                                        if (Array.isArray($$obj)) {
                                                          $$eachNodes = $$obj.reduce(function($$eachNodes, subSectionItem, $index) {
                                                            $$iterated = true;
                                                            return $$eachNodes.concat((function() {
                                                              var __jade_nodes = [];
                                                              __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                              return __jade_nodes
                                                            }).call(this));
                                                          }, []);
                                                        } else {
                                                          $$eachNodes = [];
                                                          for (var $$objKey in $$obj) {
                                                            (function() {
                                                              var $index = $$objKey;
                                                              if ($$obj.hasOwnProperty($index)) {
                                                                $$iterated = true;
                                                                var subSectionItem = $$obj[$index];
                                                                $$eachNodes = $$eachNodes.concat((function() {
                                                                  var __jade_nodes = [];
                                                                  __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                                  return __jade_nodes
                                                                }).call(this));
                                                              }
                                                            })();
                                                          }
                                                        }

                                                        return $$eachNodes;
                                                      })());;
                                                      return __jade_nodes
                                                    }).call(this).filter(Boolean)));;
                                                    return __jade_nodes
                                                  }).call(this));
                                                }
                                              })();
                                            }
                                          }

                                          return $$eachNodes;
                                        })());;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this)) : ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, item));;
                                    return __jade_nodes
                                  }).call(this)));;
                                  return __jade_nodes
                                }).call(this));
                              }
                            })();
                          }
                        }

                        return $$eachNodes;
                      })());;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var section = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'chart-tooltip-section-container': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((function() {
                            var $$obj = (section);
                            var $$eachNodes;
                            var $$iterated = false;
                            if (Array.isArray($$obj)) {
                              $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                                $$iterated = true;
                                return $$eachNodes.concat((function() {
                                  var __jade_nodes = []; /*  there are subsections to be rendered */
                                  __jade_nodes = __jade_nodes.concat((item.subsections) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'chart-tooltip-subsection-container': true
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "style": {
                                          'background': $helpers.getItemBackground(item)
                                        },
                                        "class": {
                                          'chart-tooltip-section-color-indicator': true
                                        },
                                      }));
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'chart-tooltip-subsection-item-container': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = []; /*  title of the subsection */
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, item));
                                        __jade_nodes = __jade_nodes.concat((function() {
                                          var $$obj = (item.subsections);
                                          var $$eachNodes;
                                          var $$iterated = false;
                                          if (Array.isArray($$obj)) {
                                            $$eachNodes = $$obj.reduce(function($$eachNodes, subsection, $index) {
                                              $$iterated = true;
                                              return $$eachNodes.concat((function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "class": {
                                                    'chart-tooltip-subsection-items': true
                                                  },
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat((function() {
                                                    var $$obj = (subsection);
                                                    var $$eachNodes;
                                                    var $$iterated = false;
                                                    if (Array.isArray($$obj)) {
                                                      $$eachNodes = $$obj.reduce(function($$eachNodes, subSectionItem, $index) {
                                                        $$iterated = true;
                                                        return $$eachNodes.concat((function() {
                                                          var __jade_nodes = [];
                                                          __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                          return __jade_nodes
                                                        }).call(this));
                                                      }, []);
                                                    } else {
                                                      $$eachNodes = [];
                                                      for (var $$objKey in $$obj) {
                                                        (function() {
                                                          var $index = $$objKey;
                                                          if ($$obj.hasOwnProperty($index)) {
                                                            $$iterated = true;
                                                            var subSectionItem = $$obj[$index];
                                                            $$eachNodes = $$eachNodes.concat((function() {
                                                              var __jade_nodes = [];
                                                              __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                              return __jade_nodes
                                                            }).call(this));
                                                          }
                                                        })();
                                                      }
                                                    }

                                                    return $$eachNodes;
                                                  })());;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));;
                                                return __jade_nodes
                                              }).call(this));
                                            }, []);
                                          } else {
                                            $$eachNodes = [];
                                            for (var $$objKey in $$obj) {
                                              (function() {
                                                var $index = $$objKey;
                                                if ($$obj.hasOwnProperty($index)) {
                                                  $$iterated = true;
                                                  var subsection = $$obj[$index];
                                                  $$eachNodes = $$eachNodes.concat((function() {
                                                    var __jade_nodes = [];
                                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                                      "class": {
                                                        'chart-tooltip-subsection-items': true
                                                      },
                                                    }, (function() {
                                                      var __jade_nodes = [];
                                                      __jade_nodes = __jade_nodes.concat((function() {
                                                        var $$obj = (subsection);
                                                        var $$eachNodes;
                                                        var $$iterated = false;
                                                        if (Array.isArray($$obj)) {
                                                          $$eachNodes = $$obj.reduce(function($$eachNodes, subSectionItem, $index) {
                                                            $$iterated = true;
                                                            return $$eachNodes.concat((function() {
                                                              var __jade_nodes = [];
                                                              __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                              return __jade_nodes
                                                            }).call(this));
                                                          }, []);
                                                        } else {
                                                          $$eachNodes = [];
                                                          for (var $$objKey in $$obj) {
                                                            (function() {
                                                              var $index = $$objKey;
                                                              if ($$obj.hasOwnProperty($index)) {
                                                                $$iterated = true;
                                                                var subSectionItem = $$obj[$index];
                                                                $$eachNodes = $$eachNodes.concat((function() {
                                                                  var __jade_nodes = [];
                                                                  __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                                  return __jade_nodes
                                                                }).call(this));
                                                              }
                                                            })();
                                                          }
                                                        }

                                                        return $$eachNodes;
                                                      })());;
                                                      return __jade_nodes
                                                    }).call(this).filter(Boolean)));;
                                                    return __jade_nodes
                                                  }).call(this));
                                                }
                                              })();
                                            }
                                          }

                                          return $$eachNodes;
                                        })());;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this)) : ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, item));;
                                    return __jade_nodes
                                  }).call(this)));;
                                  return __jade_nodes
                                }).call(this));
                              }, []);
                            } else {
                              $$eachNodes = [];
                              for (var $$objKey in $$obj) {
                                (function() {
                                  var $index = $$objKey;
                                  if ($$obj.hasOwnProperty($index)) {
                                    $$iterated = true;
                                    var item = $$obj[$index];
                                    $$eachNodes = $$eachNodes.concat((function() {
                                      var __jade_nodes = []; /*  there are subsections to be rendered */
                                      __jade_nodes = __jade_nodes.concat((item.subsections) ? ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "class": {
                                            'chart-tooltip-subsection-container': true
                                          },
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "style": {
                                              'background': $helpers.getItemBackground(item)
                                            },
                                            "class": {
                                              'chart-tooltip-section-color-indicator': true
                                            },
                                          }));
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'chart-tooltip-subsection-item-container': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = []; /*  title of the subsection */
                                            __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, item));
                                            __jade_nodes = __jade_nodes.concat((function() {
                                              var $$obj = (item.subsections);
                                              var $$eachNodes;
                                              var $$iterated = false;
                                              if (Array.isArray($$obj)) {
                                                $$eachNodes = $$obj.reduce(function($$eachNodes, subsection, $index) {
                                                  $$iterated = true;
                                                  return $$eachNodes.concat((function() {
                                                    var __jade_nodes = [];
                                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                                      "class": {
                                                        'chart-tooltip-subsection-items': true
                                                      },
                                                    }, (function() {
                                                      var __jade_nodes = [];
                                                      __jade_nodes = __jade_nodes.concat((function() {
                                                        var $$obj = (subsection);
                                                        var $$eachNodes;
                                                        var $$iterated = false;
                                                        if (Array.isArray($$obj)) {
                                                          $$eachNodes = $$obj.reduce(function($$eachNodes, subSectionItem, $index) {
                                                            $$iterated = true;
                                                            return $$eachNodes.concat((function() {
                                                              var __jade_nodes = [];
                                                              __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                              return __jade_nodes
                                                            }).call(this));
                                                          }, []);
                                                        } else {
                                                          $$eachNodes = [];
                                                          for (var $$objKey in $$obj) {
                                                            (function() {
                                                              var $index = $$objKey;
                                                              if ($$obj.hasOwnProperty($index)) {
                                                                $$iterated = true;
                                                                var subSectionItem = $$obj[$index];
                                                                $$eachNodes = $$eachNodes.concat((function() {
                                                                  var __jade_nodes = [];
                                                                  __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                                  return __jade_nodes
                                                                }).call(this));
                                                              }
                                                            })();
                                                          }
                                                        }

                                                        return $$eachNodes;
                                                      })());;
                                                      return __jade_nodes
                                                    }).call(this).filter(Boolean)));;
                                                    return __jade_nodes
                                                  }).call(this));
                                                }, []);
                                              } else {
                                                $$eachNodes = [];
                                                for (var $$objKey in $$obj) {
                                                  (function() {
                                                    var $index = $$objKey;
                                                    if ($$obj.hasOwnProperty($index)) {
                                                      $$iterated = true;
                                                      var subsection = $$obj[$index];
                                                      $$eachNodes = $$eachNodes.concat((function() {
                                                        var __jade_nodes = [];
                                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                                          "class": {
                                                            'chart-tooltip-subsection-items': true
                                                          },
                                                        }, (function() {
                                                          var __jade_nodes = [];
                                                          __jade_nodes = __jade_nodes.concat((function() {
                                                            var $$obj = (subsection);
                                                            var $$eachNodes;
                                                            var $$iterated = false;
                                                            if (Array.isArray($$obj)) {
                                                              $$eachNodes = $$obj.reduce(function($$eachNodes, subSectionItem, $index) {
                                                                $$iterated = true;
                                                                return $$eachNodes.concat((function() {
                                                                  var __jade_nodes = [];
                                                                  __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                                  return __jade_nodes
                                                                }).call(this));
                                                              }, []);
                                                            } else {
                                                              $$eachNodes = [];
                                                              for (var $$objKey in $$obj) {
                                                                (function() {
                                                                  var $index = $$objKey;
                                                                  if ($$obj.hasOwnProperty($index)) {
                                                                    $$iterated = true;
                                                                    var subSectionItem = $$obj[$index];
                                                                    $$eachNodes = $$eachNodes.concat((function() {
                                                                      var __jade_nodes = [];
                                                                      __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, subSectionItem));;
                                                                      return __jade_nodes
                                                                    }).call(this));
                                                                  }
                                                                })();
                                                              }
                                                            }

                                                            return $$eachNodes;
                                                          })());;
                                                          return __jade_nodes
                                                        }).call(this).filter(Boolean)));;
                                                        return __jade_nodes
                                                      }).call(this));
                                                    }
                                                  })();
                                                }
                                              }

                                              return $$eachNodes;
                                            })());;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this)) : ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['chartTooltipItem'].call(this, item));;
                                        return __jade_nodes
                                      }).call(this)));;
                                      return __jade_nodes
                                    }).call(this));
                                  }
                                })();
                              }
                            }

                            return $$eachNodes;
                          })());;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(($attr(`footer-text`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'chart-tooltip-footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode($attr(`footer-text`))]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;